import { createFileRoute } from '@tanstack/react-router';

import { TamMapPage } from '@apps/web/components/admin/tam_map/tam_map_page';

export const Route = createFileRoute('/_app/admin/tam-map')({
    head: () => ({ meta: [{ title: 'Unified TAM Map | Phoebe Admin' }] }),
    component: TamMapPage,
});
